<template src="./TeaserSkeleton.html"></template>
<style src="./TeaserSkeleton.scss" lang="scss"></style>

<script>
	import TeaserSkeletonElement from '@/components/TeaserSkeletonElement/TeaserSkeletonElement';

	export default {
		name: 'HpTeaserSkeleton',
		components: {
			'hp-teaser-skeleton-element': TeaserSkeletonElement
		},
		props: {
			fixedTypes: {
				type: Object,
				default: () => {}
			},
			randomTypes: {
				type: Array,
				default: () => ['rectangle', 'teaser-1', 'teaser-2', 'teaser-3'],
				validator: randomTypes => randomTypes.every((type) => ['rectangle', 'teaser-1', 'teaser-2', 'teaser-3'].includes(type))
			},
			count: {
				type: Number,
				default: 15
			}
		},
		methods: {
			/**
			 * Returns a random number from the length of a given array
			 * @param {Array} arr Array which is used to calculate a random number
			 */
			getRandomElement(arr) {
				return arr[Math.floor(Math.random() * arr.length)]
			}
		},
		computed: {
			/**
			 * Creates an array with fixed and/or random positioned elements
			 */
			skeletonElements() {
				const elementsArr = [];

				for (let n = 1; n <= this.count; n++) {
					this.fixedTypes && this.fixedTypes[n] ? elementsArr.push(this.fixedTypes[n]) : elementsArr.push(this.getRandomElement(this.randomTypes));
				}

				return elementsArr;
			}
		}
	};
</script>
